module.exports = __webpack_public_path__ + "img/9791195567829.268de2ec.jpg";